export enum Degrees {
  LESS_THAN_SECONDARY = 'Less than Secondary / High School',
  SECONDARY = 'Secondary / High School',
  CEGEP = 'CEGEP',
  COLLEGE = 'Undergraduate University (2 year - community college or similar)',
  UNDERGRADUATE = 'Undergraduate University (3+ year)',
  GRADUATE = 'Graduate University (Masters, Professional, Doctoral, etc)',
  CODE_SCHOOL = 'Code School / Bootcamp',
  VOCATIONAL = 'Other Vocational / Trade Program or Apprenticeship',
  POSTDOC = 'Post Doctorate',
  OTHER = 'Other',
  NOT_STUDENT = "I'm not currently a student",
  NO_ANSWER = 'Prefer not to answer',
}
export default Degrees;
